import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'devextreme/dist/css/dx.light.css';  // <- IMPORTANT

ReactDOM.render(
<App />,
  document.getElementById('root')
);

reportWebVitals();